import { useTranslations } from 'next-intl';
import { InnerHTML } from '@headless-workspace/domain/common/client';
import { PaymentMethodsValue } from '@headless-workspace/domain/common/server';
import { GlowTextBody, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type ProductDetailBuyNowPayLaterTextProps = PropsWithFontFamily & {
    buyNowPayLaterContent: PaymentMethodsValue;
};

export const ProductDetailBuyNowPayLaterText: Component<ProductDetailBuyNowPayLaterTextProps> = ({
    buyNowPayLaterContent,
    fontFamily,
}) => {
    const t = useTranslations('Discover.Pdp.information.buyNowPayLater');

    const paymentMethods =
        buyNowPayLaterContent.items?.map(
            (element) =>
                `<a class='text-underline' href='${buyNowPayLaterContent.paymentMethodsUrl}'>${element.name}</a>`,
        ) || [];

    if (paymentMethods.length === 0) {
        return null;
    }

    const content =
        paymentMethods.length === 1
            ? `<p >${t('label.multiInstallmentWith')} ${paymentMethods[0]}</p>`
            : `<p >${t('label.multiInstallmentWith')} ${paymentMethods.slice(0, -1).join(', ')} ${t('label.or')} ${paymentMethods[paymentMethods.length - 1]}</p>`;
    return (
        <GlowTextBody
            fontFamily={fontFamily}
            className="mt-1"
            data-testid="payment-method-info"
            innerHTML={<InnerHTML rawHtml={{ content }} />}
        />
    );
};
